const VALUES = [
    {value:'ATI',display:'ATI - Aid to Israel'},
    {value:'B', display:'DN - Discount Notes'},
    {value:'FAMC', display:'FAMC - Federal Agriculture Mortgage Corporation'},
    {value:'FFCB', display:'FFCB - Federal Farm Credit Banks'},
    {value:'FHA', display:'FHA - Farmers Home Administration'},
    {value:'FHLB', display:'FHLB - Federal Home Loan Banks'},
    {value:'FHLMC', display:'FHLMC - Federal Home Loan Mortgage Corporation'},
    {value:'FICO', display:'FICO - Financing Corp'},
    {value:'FJOB', display:'FJOB - Federal Judiciary Office Building'},
    {value:'FNMA', display:'FNMA - Federal National Mortgage Association'},
    {value:'GNMA', display:'GNMA - Government National Mortgage Association'},
    {value:'HUD', display:'HUB - Housing & Urban Development'},
    {value:'SBA', display:'SBA - Small Business Administration'},
    {value:'SLMA', display:'SLMA - Student Loan Marketing Association'},
    {value:'TVA', display:'TVA - Tennessee Valley Authority'},
    {value:'OTHER', display:'OTHER - All else'}
]

export const AGENCY_TYPES = VALUES
    .map(({value, display}) => {
        return {
            label: display,
            display,
            value: 'holdAgencyType=' + encodeURIComponent(value)
        }
    })


export const AGENCY_TYPE_LABELS = Object.fromEntries(VALUES.map(a=> [a.value,a.display]))


// WEBPACK FOOTER //
// ./src/twd/values/agency-types.js